export class BillingHistoryDetails {
  id: string;
  status: number;
  amount: number;
  date: Date;
  method: string;
}
